exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.search_member-popup .ant-modal-footer[data-v-1cb92f6c] {\n  padding: 10px 16px;\n  text-align: right;\n  border-top: 1px solid #e8e8e8;\n  border-radius: 0 0 6px 6px;\n  display: none;\n}\n.modal_searchdata[data-v-1cb92f6c] {\n  margin-bottom: 15px;\n  border: 1px solid #d9d9d9;\n  padding: 5px;\n  border-radius: 5px;\n  width: 100%;\n  margin-left: 0px !important;\n}\n.modal_searchdata button.ant-btn-block.ant-btn.ant-btn-sm.ant-btn-block[data-v-1cb92f6c] {\n  margin: 5px 0;\n}\n.modal_searchdata_container[data-v-1cb92f6c] {\n  max-height: 40vh;\n  overflow: auto;\n  width: 100%;\n}\n", ""]);

// exports
